import React from 'react';
import "./offer.css"

const Offer = (props) => {
    return ( 
        <>
            <div className={props.ofstyle}>
                <img src={props.icon} alt="" />
                <span>{props.num}</span>
            </div>
        
        </>
     );
}
 
export default Offer;